import store from '@/store'
import sweetalertUtil from '@/utils/sweetalertUtil'
import i18n from '@/translations'
import {checkPermission} from '@/utils/permissionsUtil'

const verifyTokenGuard = async (to, from, next) => {

    const token = store.getters["auth/getToken"]
    const isExpired = store.getters['auth/isExpired']
    const loggedUser = store.getters['auth/getLoggedUser']
    const isNeedsAcceptNoticeOfPrivacy = store.getters['auth/getIsNeedsAcceptNoticeOfPrivacy']


    if (isNeedsAcceptNoticeOfPrivacy) {
        return next({name: 'notice_privacy-index'})
    } else if (isExpired) {

        const {message, error} = await store.dispatch('auth/refreshToken')

        if (error) {

            await store.dispatch('auth/clearAuthToken')

            return next({name: 'auth-login'})
        }

        if (checkPermission(to.name)) {
            return next()
        } else {

            sweetalertUtil.fire({
                icon: 'error',
                title: 'Error',
                html: i18n.global.messages.value[i18n.global.locale.value]['errors']['has-permission'],
            })
            return next({name: from.name})
        }

    } else if (!token || isExpired) {
        return next({name: 'auth-login'})
    } else {

        //Needs to change password
        const passwordExpired = store.getters['auth/isPasswordExpired']
        const forcePasswordChange = store.getters['auth/isForcePasswordChange']
        const requiresClinicalProfileCompletion = store.getters['auth/requiresClinicalProfileCompletion']

        if (passwordExpired) {
            return next({name: 'change-password-expired-edit'})
        } else if (forcePasswordChange) {
            // Determinar la ruta de perfil según el tipo de usuario
            const isPatient = loggedUser?.role_name === 'Paciente'
            const profileRoute = isPatient ? 'patient-profile-edit' : 'profile-edit'

            // Solo redirigir si no está yendo ya a su ruta de perfil correspondiente
            if (to.name !== profileRoute) {
                const forceCompleteProfile = i18n.global.messages.value[i18n.global.locale.value]['force-complete-profile']
                const isProfessionalHealth = Number(loggedUser?.role_type_id) === 1
                const forceCompleteProfileMessage = isProfessionalHealth
                    ? (forceCompleteProfile?.['alert-message'] || 'Para garantizar la seguridad de tu cuenta y el correcto funcionamiento del sistema, debes cambiar tu contraseña temporal y completar tu información de perfil.')
                    : (forceCompleteProfile?.['admin-alert-message'] || 'Para garantizar la seguridad de tu cuenta, debes cambiar tu contraseña temporal.')

                sweetalertUtil.fire({
                    icon: 'warning',
                    title: forceCompleteProfile?.title || 'Acción requerida',
                    html: forceCompleteProfileMessage,
                    confirmButtonText: i18n.global.messages.value[i18n.global.locale.value]['accept'] || 'Aceptar',
                })
                return next({name: profileRoute})
            } else {
                return next()
            }
        } else if (requiresClinicalProfileCompletion) {
            if (to.name !== 'profile-edit') {
                sweetalertUtil.fire({
                    icon: 'warning',
                    title: i18n.global.messages.value[i18n.global.locale.value]['clinical-profile-incomplete']['title'] || 'Acción requerida',
                    html: i18n.global.messages.value[i18n.global.locale.value]['clinical-profile-incomplete']['alert-message'] || 'Debes completar tu perfil clínico antes de continuar.',
                    confirmButtonText: i18n.global.messages.value[i18n.global.locale.value]['accept'] || 'Aceptar',
                })
                return next({name: 'profile-edit'})
            } else {
                return next()
            }
        } else if (checkPermission(to.name)) {
            return next()
        } else {
            sweetalertUtil.fire({
                icon: 'error',
                title: 'Error',
                html: i18n.global.messages.value[i18n.global.locale.value]['errors']['has-permission'],
            })
            return next({name: from.name})
        }

    }

}

export default verifyTokenGuard
